import React, { useEffect, useRef, useState } from 'react'
import { convert64 } from '../../utils/images_manager';

import axios from 'axios';
import { api } from '../../settings/env';
import ProductModal from '../../components/product-modal/ProductModal';

export default function ServicePage() {

    const [products, setProducts] = useState([])

    const [nameProduct, setNameProduct] = useState("");
    const [descriptionProduct, setDescriptionProduct] = useState("");
    const [priceProduct, setPriceProduct] = useState(0.00);

    const [loader, setLoader] = useState(false);
    const [modalProduct, setModalProduct] = useState(false);
    const [productSelected, setProductSelected] = useState(false);

    const [profile, setProfile] = useState(false);
    const imgProfileRef = useRef()
    const closeModal = useRef()

    const handleImage = async (e) => {
        try {
            const management_image = await convert64(e);

            console.log("MANAGEMENT IMAGE", management_image);

            if (management_image && management_image !== null) {
                console.log("Entró en true");
                setProfile(management_image); // Aquí puedes guardar la imagen convertida
            } else {
                console.log("Reseteando el input debido a un error");
                imgProfileRef.current.value = ""; // Reinicia el campo de entrada
                alert("Hubo un problema con la imagen. Por favor, intenta con otro archivo.");
            }
        } catch (error) {
            console.error("Error al manejar la imagen:", error);
            imgProfileRef.current.value = ""; // Reinicia el campo si ocurre un error
            alert("Ocurrió un error al procesar la imagen. Por favor, inténtalo nuevamente.");
        }
    };

    const handleAddProduct = () => {
        if(loader){
            return
        }

        // Activar loader
        setLoader(true);
        // Agregar nuevo producto a la lista
        const newProduct = {
            name: nameProduct,
            description: descriptionProduct,
            price: parseFloat(priceProduct),
            image: profile, 
            professionalId: localStorage.getItem("vitaly_userid")
        }
        
        //setProducts([...products, newProduct])

        axios.post(`${api}/services/create`, newProduct)
        .then(resp => {
            console.log(resp.data);
            setLoader(false);
            getProducts();
            closeModal.current.click()
        })
        .catch(err => setLoader(false))

    }

    const getProducts = () => {
        const id = localStorage.getItem("vitaly_userid");
        axios.get(`${api}/services/${id}`)
        .then(resp => {
            console.log(resp.data.data)
            setProducts(resp.data.data)

        })
        .catch(err => console.log(err))
    }


    useEffect(() => {
        getProducts();
    }, [])

    const openDetails = (product) => {
        console.log(product);
        setProductSelected(product);
        setModalProduct(true);
    }

    const closeModalProduct = () => setModalProduct(false)

    return (
        <div className='page-admin container py-4'
            style={{
                alignItems: "start"
            }}
        >

            {
                modalProduct && <ProductModal type="servicio" product={productSelected} close={closeModalProduct} getProducts={getProducts} />
            }

            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                                Crear nuevo servicio
                            </h5>
                            <button ref={closeModal} type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row g-3 align-items-center">

                                <div class="col-auto">
                                    <input
                                        onKeyUp={(e) => setNameProduct(e.target.value)}
                                        placeholder='Nombre' type="text" class="form-control" />
                                </div>

                                <div class="col-auto">
                                    <textarea
                                        onKeyUp={(e) => setDescriptionProduct(e.target.value)}
                                        style={{ height: "100px" }}
                                        placeholder='Descripción' type="textarea" class="form-control" />                                </div>

                                <div class="col-auto">
                                    <input
                                        onKeyUp={(e) => setPriceProduct(e.target.value)}
                                        placeholder='Precio' type="number" class="form-control" />
                                </div>

                                <label htmlFor="">Imagen</label>
                                <div class="col-auto">
                                    <input
                                        placeholder='Imagen'
                                        type="file"
                                        class="form-control"
                                        ref={imgProfileRef}
                                        onChange={handleImage}
                                    />
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                            <button type="button" onClick={handleAddProduct} class="btn btn-primary">
                                {loader ? "Creando..." : "Crear"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <h1>Servicios</h1>
            <p className='text-center'>Lista de servicios registrados</p>


            <div className="grid-products">
                <div data-bs-toggle="modal" data-bs-target="#exampleModal" className="new-product-card">
                    <img width={"80%"} src="https://t4.ftcdn.net/jpg/03/16/59/73/360_F_316597363_G8dPZwXqbsq9vs7uiomI9gIlwdT7sywy.jpg" alt="" />

                    <button className="btn btn-primary">
                        Agregar
                    </button>
                </div>

                {
                    products && products.map(product => (
                        <div key={product.id} className="product-card">
                            <img width={"100%"} height={"184px"} src={product.image} alt="" />
                            <h5 className='mt-2'>{product.name}</h5>
                            <p>{product.price}$</p>
                            
                            <button className="btn btn-primary" onClick={(e) => openDetails(product)}>
                                Ver detalle
                            </button>
                        </div>
                    ))
                }
            </div>

        </div>
    )
}
